import { UPDATE_INFO_SCHEDULE } from './type';

// CART
export const updateInfoScheduleStore = (payload) => {
    return {
        type: UPDATE_INFO_SCHEDULE,
        payload,
    };
};
